module.exports = __webpack_public_path__ + "static/txtling1-768x681-4dd022c97f47617abf9abcf80c2c7630.png";